import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import Config from '../../../../../../Config';
import SwiperCore, {Navigation, Pagination, Autoplay} from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
SwiperCore.use([Pagination, Navigation, Autoplay]);

const ChannelsSwiper = (props) => {
  return (
    <Swiper
      className='swiper-item'
      modules={[Navigation]}
      navigation={props.hideNavigationBtn ? false : props.channels?.length > 3 ? true : false}
      centerInsufficientSlides={false}
      spaceBetween={15}
      slidesPerView={'auto'}
      scrollbar={{draggable: true}}
      centeredSlidesBounds={true}
      centeredSlides={false}
      enabled={props.channels?.length > 3}
      autoplay={{delay: 0, disableOnInteraction: false}}
      pauseOnMouseEnter={true}
      speed={4000}
      setWrapperSize={true}
      loop={props.channels?.length > 3}>
      {props.channels?.map((channel, i) => (
        <SwiperSlide key={i}>
          <div className='chanel-wrapper'>
            <Image src={Config.epiBaseUrl + channel.image} alt='channel picture' />
            <span className='chanel-name'>{channel.channelName}</span>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
export default ChannelsSwiper;
